import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthLoginGuard } from './core/guards/authLogin.guard';
import { PincodeGuard } from './core/guards/pincode.guard';
import { NotFoundComponent } from './components/not-found/not-found.component';

const tmpPath = ':lang/shprofile';
const baseP = 'shprofile';
const routes: Routes = [
  {
    path: tmpPath,
    pathMatch: 'full',
    loadChildren: () => import('./modules/login/login.module').then(m => m.LoginModule)
  },
  {
    path: baseP,
    pathMatch: 'full',
    loadChildren: () => import('./modules/login/login.module').then(m => m.LoginModule)
  },
  {
    path: `${tmpPath}/login`,
    loadChildren: () => import('./modules/login/login.module').then(m => m.LoginModule)
  },
  {
    path: `${baseP}/login`,
    loadChildren: () => import('./modules/login/login.module').then(m => m.LoginModule)
  },
  {
    path: `${tmpPath}/pin-code`,
    loadChildren: () => import('./modules/pin-code/pin-code.module').then(m => m.PincodeModule),
    canActivate: [PincodeGuard]
  },
  {
    path: `${baseP}/pin-code`,
    loadChildren: () => import('./modules/pin-code/pin-code.module').then(m => m.PincodeModule),
    canActivate: [PincodeGuard]
  },
  {
    path: `${tmpPath}/register`,
    loadChildren: () => import('./modules/register/register.module').then(m => m.RegisterModule)
  },
  {
    path: `${baseP}/register`,
    loadChildren: () => import('./modules/register/register.module').then(m => m.RegisterModule)
  },
  {
    path: `${tmpPath}/member`,
    loadChildren: () => import('./modules/member/member.module').then(m => m.MemberModule)
  },
  {
    path: `${baseP}/member`,
    loadChildren: () => import('./modules/member/member.module').then(m => m.MemberModule)
  },
  {
    path: `${tmpPath}/profile`,
    loadChildren: () => import('./modules/edit-profile/edit-profile.module').then(m => m.EditProfileModule)
  },
  {
    path: `${baseP}/profile`,
    loadChildren: () => import('./modules/edit-profile/edit-profile.module').then(m => m.EditProfileModule)
  },
  {
    path: `${tmpPath}/edit-pwd`,
    loadChildren: () => import('./modules/edit-password/edit-password.module').then(m => m.EditPasswordModule),
  },
  {
    path: `${baseP}/edit-pwd`,
    loadChildren: () => import('./modules/edit-password/edit-password.module').then(m => m.EditPasswordModule),
  },
  {
    path: `${tmpPath}/visitor`,
    loadChildren: () => import('./modules/realname/realname.module').then(m => m.RealnameModule),
    canActivate: [AuthLoginGuard],
  },
  {
    path: `${baseP}/visitor`,
    loadChildren: () => import('./modules/realname/realname.module').then(m => m.RealnameModule),
    canActivate: [AuthLoginGuard],
  },
  {
    path: `${tmpPath}/license`,
    loadChildren: () => import('./modules/license/license.module').then(m => m.LicenseModule),
  },
  {
    path: `${baseP}/license`,
    loadChildren: () => import('./modules/license/license.module').then(m => m.LicenseModule),
  },
  {
    path: `${tmpPath}/cookie-loading`,
    loadChildren: () => import('./modules/loading/loading.module').then(m => m.LoadingModule),
  },
  {
    path: `${baseP}/cookie-loading`,
    loadChildren: () => import('./modules/loading/loading.module').then(m => m.LoadingModule),
  },
  {
    path: `**`,
    component: NotFoundComponent,
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }